import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable, ReplaySubject } from 'rxjs';
import { SelectedSiteService } from '../../selected-site.service';
import { ApiErrorFactory } from '../api-errors';
import { CdnResponseJSON, CdnState } from './cdn';

@Injectable()
export class CdnApiService {
  private readonly headers = new HttpHeaders().set('Content-Type', 'application/json');
  private readonly siteUrlV2 = '/api/v2/site/';
  private siteId: string;
  private cdnState$$: ReplaySubject<CdnState> = new ReplaySubject<CdnState>(1);
  private loading$$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private http: HttpClient,
    private selectedSiteService: SelectedSiteService,
    private apiErrorFactory: ApiErrorFactory,
    private alertService: SnackbarService,
  ) {
    this.selectedSiteService.getSiteId().subscribe((siteId: string) => (this.siteId = siteId));
  }

  public loadCdnState(): void {
    this.loading$$.next(true);
    this.http.get<CdnResponseJSON>(this.getCdnUrl(this.siteId)).subscribe(
      (resp) => this.handleHttpResponse(resp),
      (err) => this.handleHttpError(err),
    );
  }

  public setCdn(enabled: boolean): void {
    const body = {
      enabled: enabled,
    };
    this.loading$$.next(true);
    this.http
      .post<CdnResponseJSON>(this.getCdnUrl(this.siteId), body, {
        headers: this.headers,
      })
      .subscribe(
        (resp) => this.handleHttpResponse(resp),
        (err) => this.handleHttpError(err),
      );
  }

  public getCdnState$(): Observable<CdnState> {
    return this.cdnState$$.asObservable();
  }

  public getLoading$(): Observable<boolean> {
    return this.loading$$.asObservable();
  }

  private getCdnUrl(siteId: string): string {
    return this.siteUrlV2 + siteId + '/cdn/';
  }

  private handleHttpResponse(response: CdnResponseJSON): void {
    this.cdnState$$.next(CdnState.fromJSON(response.data));
    this.loading$$.next(false);
  }

  private handleHttpError(err: HttpErrorResponse): void {
    const parsedError = this.apiErrorFactory.parseErrorResponse(err);
    this.alertService.openErrorSnack(parsedError.getUserMessage());
    this.loading$$.next(false);
  }
}
